export default "__VITE_ASSET__Dny$XDcx__"